import { baseURLForAssets } from "./signals";

export function urlPath(applicationPath: string, tenantId: string | undefined) {
  if (tenantId && applicationPath === "/") {
    return `/${tenantId}`;
  }
  if (tenantId) {
    return `/${tenantId}${applicationPath}`;
  }
  return applicationPath;
}

function absoluteURL(baseURL: string, value: string) {
  if (value.length > 0 && value[0] !== "/" && !value.startsWith("http")) {
    if (!baseURL.endsWith("/")) {
      baseURL = baseURL + "/";
    }
    if (value.startsWith("./")) {
      value = value.slice(2);
    }
    value = `${baseURL}${value}`;
  }
  return value;
}

export function absoluteURLForAsset(value: string | undefined) {
  if (!value) return "";
  const baseURL = baseURLForAssets();
  // Remove non existing hubs domain anymore, try to get the file locally
  value = value.replace("https://uploads-prod.reticulum.io/files/", "");
  return absoluteURL(baseURL, value);
}

export function relativeURLForAsset(value: string | undefined) {
  if (!value) return "";
  return value.replaceAll(baseURLForAssets(), "");
}

export function transformComponentValueToUseAbsoluteURLForAsset(
  componentName: string,
  componentValue: string | object
) {
  if (componentName === "load360onclick" || componentName === "gltf-model") {
    componentValue = absoluteURLForAsset(componentValue as string);
    return componentValue;
  }

  let objectCopyDone = false;
  if (
    typeof componentValue === "string" &&
    (componentValue.indexOf("src:") > -1 ||
      componentValue.indexOf("texture:") > -1 ||
      componentValue.indexOf("map:") > -1)
  ) {
    componentValue = AFRAME.utils.styleParser.parse(componentValue);
    objectCopyDone = true;
  }

  if (typeof componentValue === "object") {
    if (!objectCopyDone) {
      componentValue = { ...componentValue };
    }
    // @ts-ignore
    if (componentValue.src) {
      // @ts-ignore
      componentValue.src = absoluteURLForAsset(componentValue.src);
    }
    // @ts-ignore
    if (componentValue.texture) {
      // particles component
      // @ts-ignore
      componentValue.texture = absoluteURLForAsset(componentValue.texture);
    }
    // @ts-ignore
    if (componentValue.map) {
      // @ts-ignore
      componentValue.map = absoluteURLForAsset(componentValue.map);
    }
  }

  return componentValue;
}

export function transformComponentValueToUseRelativeURLForAsset(
  componentName: string,
  componentValue: string | object
) {
  if (componentName === "load360onclick" || componentName === "gltf-model") {
    componentValue = relativeURLForAsset(componentValue as string);
    return componentValue;
  }

  if (
    typeof componentValue === "string" &&
    (componentValue.indexOf("src:") > -1 ||
      componentValue.indexOf("texture:") > -1 ||
      componentValue.indexOf("map:") > -1)
  ) {
    componentValue = relativeURLForAsset(componentValue);
  }

  if (typeof componentValue === "object") {
    componentValue = { ...componentValue };
    // @ts-ignore
    if (componentValue.src) {
      // @ts-ignore
      componentValue.src = relativeURLForAsset(componentValue.src);
    }
    // @ts-ignore
    if (componentValue.texture) {
      // particles component
      // @ts-ignore
      componentValue.texture = relativeURLForAsset(componentValue.texture);
    }
    // @ts-ignore
    if (componentValue.map) {
      // @ts-ignore
      componentValue.map = relativeURLForAsset(componentValue.map);
    }
  }

  return componentValue;
}
